import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const users = {
  data: {
    directAccesses: [
      {
        id: "85dc9562-58d3-8738-9735-ca2139a83809",
        avatar: "",
        name: "Charlotte Zhuang",
        email: "Charlotte.Zhuang@mail.com",
        orgRoleName: "Viewer",
        orgRoleId: 7,
        siteAccesses: [
          {
            siteName: "Taipei",
            siteId: "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f",
            siteRoleName: "Viewer",
            siteRoleId: 10,
          },
        ],
        status: "inactive",
        timeOfAuth: 1736356148,
        lastLoginTime: 1736312346,
      },
      {
        id: "aa997107-4cbc-db83-53e2-4433514aa96a",
        avatar: "",
        email: "user003@mail.com",
        orgRoleName: "Viewer",
        orgRoleId: 7,
        siteAccesses: [
          {
            siteName: "Taipei",
            siteId: "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f",
            siteRoleName: "Viewer",
            siteRoleId: 10,
          },
          {
            siteName: "Kaohsiung",
            siteId: "52c3b2b1-e9d7-43e3-b03f-c5b18b4a9e9e",
            siteRoleName: "Admin",
            siteRoleId: 9,
          },
        ],
        status: "Active",
        timeOfAuth: 1736399854,
        lastLoginTime: 1736367841,
      },
      {
        id: "1abb1a8d-cd93-9471-08ca-528b9c316ca8",
        avatar: "",
        name: "Amy",
        email: "fgsfsf333@mail.com",
        orgRoleName: "Super Admin",
        orgRoleId: 5,
        siteAccesses: [],
        status: "active",
        timeOfAuth: 1736354321,
        lastLoginTime: 1736356723,
      },
      {
        id: "c3b2b1e9-d7e9-43e3-b03f-c5b18b4a9e9e",
        avatar: "",
        name: "Jack",
        email: "12321dfa@mail.com",
        orgRoleName: "Admin",
        orgRoleId: 6,
        siteAccesses: [],
        status: "active",
        timeOfAuth: 1736312345,
        lastLoginTime: 1736356143,
      },
    ],
    mspAccesses: [
      {
        id: "85dc9562-58d3-8738-9735-ca2139a83897",
        avatar: "",
        name: "Adam",
        email: "adam009123@mail.com",
        orgRoleName: "Viewer",
        orgRoleId: 7,
      },
      {
        id: "au997107-4cbc-db83-53e2-4433514aa96b",
        avatar: "",
        name: "Lucy",
        email: "lllasdqwd2@mail.com",
        orgRoleName: "Admin",
        orgRoleId: 6,
      },
      {
        id: "1abb1a8d-cd93-9488-08ca-528b9c316ca9",
        avatar: "",
        name: "Gina",
        email: "dc0vreded3a@mail.com",
        orgRoleName: "Admin",
        orgRoleId: 6,
      },
      {
        id: "c3b2b110-d7e9-43e3-b03f-c5b18b4a9e9f",
        avatar: "",
        name: "Vivian",
        email: "asdweedd1312@mail.com",
        orgRoleName: "Admin",
        orgRoleId: 6,
      },
    ],
  },
};

const invitations = {
  data: {
    invitations: [
      {
        invitationId: "ad93cec4-3444-8480-e65d-038b2db22c67",
        avatar: "",
        name: "李大明",
        email: "qqqqweqewqewqe123123@mail.com",
        orgRoleName: "Admin",
        orgRoleId: 6,
        siteAccesses: [
          {
            siteName: "Taipei",
            siteId: "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f",
            siteRoleName: "Admin",
            siteRoleId: 9,
          },
          {
            siteName: "Kaohsiung",
            siteId: "52c3b2b1-e9d7-43e3-b03f-c5b18b4a9e9e",
            siteRoleName: "Viewer",
            siteRoleId: 10,
          },
        ],
        timeOfInvitation: 1747892552,
      },
      {
        invitationId: "ce09d7fd-debb-dad4-2452-c606fdc1b807",
        avatar: "",
        email: "rfsdf12@mail.com",
        orgRoleName: "Admin",
        orgRoleId: 9,
        siteAccesses: [],
        timeOfInvitation: 1746859463,
      },
    ],
  },
};

const orgRoleMap = {
  5: "Super Admin",
  6: "Admin",
  7: "Viewer",
};

const siteRoleMap = {
  9: "Admin",
  10: "Viewer",
};

const siteMap = {
  "52c3b2b1-e9d7-43e3-b03f-c5b18b4a9e9e": "Kaohsiung",
  "9f0a2cce-45b8-46a4-b4cf-7e6eaa7d4e0f": "Taipei",
};

const initialState = {
  users,
  invitations,
};

export const orgUserManagementSlice = createSlice({
  name: "orgUserManagement",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.users.data = action.payload;
    },
    setInvitationUser: (state, action) => {
      state.invitations.data = action.payload;
    },
    addInvitationUser: (state, action) => {
      if (!state.invitations.data.invitations) {
        state.invitations.data.invitations = [];
      }

      const payload = action.payload;

      const newInvitation = {
        ...payload,
        invitationId: uuidv4(),
        timeOfInvitation: Math.floor(Date.now() / 1000),
        orgRoleName: orgRoleMap[payload.orgRoleId] || "Viewer",
      };

      state.invitations.data.invitations.push(newInvitation);
    },
    removeUser: (state, action) => {
      const userId = action.payload;
      state.users.data.directAccesses = state.users.data.directAccesses.filter(
        (user) => user.id !== userId
      );
    },
    removeInvitation: (state, action) => {
      const invitationId = action.payload;
      state.invitations.data.invitations =
        state.invitations.data.invitations.filter(
          (inv) => inv.invitationId !== invitationId
        );
    },
    updateUser: (state, action) => {
      const { userId, updates } = action.payload;

      const userIndex = state.users.data.directAccesses.findIndex(
        (user) => user.id === userId
      );

      if (userIndex !== -1) {
        let updatedUser = {
          ...state.users.data.directAccesses[userIndex],
          ...updates,
        };

        if (updates.orgRoleId !== undefined) {
          updatedUser.orgRoleName = orgRoleMap[updates.orgRoleId] || "Viewer";
        }

        if (updates.siteAccesses) {
          updatedUser.siteAccesses = updates.siteAccesses.map((site) => {
            let siteId = site.siteId;

            if (siteId.includes("_ID")) {
              const baseName = siteId.replace("_ID", "");
              const foundUUID = Object.keys(siteMap).find(
                (uuid) => siteMap[uuid] === baseName
              );
              if (foundUUID) {
                siteId = foundUUID;
              }
            }

            return {
              ...site,
              siteId,
              siteName: siteMap[siteId] || "Unknown Site",
              siteRoleName: siteRoleMap[site.siteRoleId] || "Viewer",
            };
          });
        }

        state.users.data.directAccesses[userIndex] = updatedUser;
      }
    },

    updateInvitation: (state, action) => {
      const { invitationId, updates } = action.payload;
      const invitationIndex = state.invitations.data.invitations.findIndex(
        (inv) => inv.invitationId === invitationId
      );

      if (invitationIndex !== -1) {
        const prevData = state.invitations.data.invitations[invitationIndex];

        let updatedInvitation = {
          ...prevData,
          ...updates,
        };

        if (updates.orgRoleId !== undefined) {
          updatedInvitation.orgRoleName =
            orgRoleMap[updates.orgRoleId] || "Viewer";
        }

        if (updates.siteAccesses) {
          updatedInvitation.siteAccesses = updates.siteAccesses.map((site) => {
            let siteId = site.siteId;

            if (siteId.includes("_ID")) {
              const baseName = siteId.replace("_ID", "");
              const foundUUID = Object.keys(siteMap).find(
                (uuid) => siteMap[uuid] === baseName
              );
              if (foundUUID) {
                siteId = foundUUID;
              }
            }

            return {
              ...site,
              siteId,
              siteName: siteMap[siteId] || "Unknown Site",
              siteRoleName: siteRoleMap[site.siteRoleId] || "Viewer",
            };
          });
        }

        state.invitations.data.invitations[invitationIndex] = updatedInvitation;
      }
    },
  },
});

export const {
  setUser,
  setInvitationUser,
  addInvitationUser,
  removeUser,
  removeInvitation,
  updateUser,
  updateInvitation,
} = orgUserManagementSlice.actions;

export default orgUserManagementSlice.reducer;
